import {createClient} from 'contentful'

export default  createClient({
    space:"jtgvvh6i4fz4",
    accessToken:"NUEEiaXb0gFIvItXNdDD9A4hEQyxPShwmEjpMbEaXQ0"
})